/* Resilient Nutrition — minimal theme JS.
   Handles mobile nav drawer, product gallery thumbs, qty steppers,
   and inline-cart line removals. */

(function () {
  "use strict";

  // ---- Drawer (mobile nav) ----------------------------------------
  const drawer = document.querySelector("[data-drawer]");
  const scrim  = document.querySelector("[data-drawer-scrim]");
  const openers = document.querySelectorAll("[data-drawer-open]");
  const closers = document.querySelectorAll("[data-drawer-close]");

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "false");
    if (scrim) scrim.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    if (scrim) scrim.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  openers.forEach((b) => b.addEventListener("click", openDrawer));
  closers.forEach((b) => b.addEventListener("click", closeDrawer));
  if (scrim) scrim.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });

  // ---- Product gallery thumbs -------------------------------------
  const mainImg = document.querySelector("[data-product-main]");
  const thumbs = document.querySelectorAll("[data-product-thumb]");
  thumbs.forEach((t) => {
    t.addEventListener("click", () => {
      const src = t.getAttribute("data-src");
      if (mainImg && src) mainImg.setAttribute("src", src);
      thumbs.forEach((x) => x.classList.remove("is-active"));
      t.classList.add("is-active");
    });
  });

  // ---- Qty steppers -----------------------------------------------
  document.querySelectorAll("[data-qty-minus]").forEach((b) => {
    b.addEventListener("click", () => {
      const input = b.parentElement.querySelector("input[type='number']");
      if (!input) return;
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
  document.querySelectorAll("[data-qty-plus]").forEach((b) => {
    b.addEventListener("click", () => {
      const input = b.parentElement.querySelector("input[type='number']");
      if (!input) return;
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  // ---- Cart line removal (form-based, no AJAX) --------------------
  document.querySelectorAll("[data-cart-remove]").forEach((b) => {
    b.addEventListener("click", (e) => {
      const form = b.closest("form");
      const key  = b.getAttribute("data-cart-remove");
      if (!form || !key) return;
      const input = form.querySelector(`input[name='updates[${key}]']`);
      if (input) input.value = 0;
      form.submit();
    });
  });

  // ---- Headline Copy & Image carousel -----------------------------
  // Each [data-rn-carousel] becomes an auto-rotating slide deck. Interval
  // is read from data-interval (ms). Dots act as manual nav; hovering the
  // media area pauses the timer if data-pause-on-hover is true. Reduced-
  // motion users get static (no auto-advance) per OS preference.
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-rn-carousel]").forEach((carousel) => {
    const slides = carousel.querySelectorAll(".rn-hci__slide");
    const dots = carousel.querySelectorAll(".rn-hci__dot");
    if (slides.length <= 1) return;

    const interval = Math.max(2000, parseInt(carousel.dataset.interval, 10) || 5000);
    const pauseOnHover = carousel.dataset.pauseOnHover === "true";
    let active = 0;
    let timer = null;

    function show(i) {
      const next = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle("is-active", idx === next));
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === next));
      active = next;
    }
    function start() {
      if (prefersReducedMotion) return;
      stop();
      timer = setInterval(() => show(active + 1), interval);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach((d) => {
      d.addEventListener("click", () => {
        const i = parseInt(d.dataset.slideIndex, 10) || 0;
        show(i);
        start(); // reset timer after manual nav
      });
    });

    if (pauseOnHover) {
      carousel.addEventListener("mouseenter", stop);
      carousel.addEventListener("mouseleave", start);
    }

    // Pause when off-screen to save work.
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? start() : stop()));
      }, { threshold: 0.1 });
      io.observe(carousel);
    } else {
      start();
    }
  });

  // ---- Brief Us form acknowledgement ------------------------------
  // The form posts to /contact via Shopify's contact-form endpoint;
  // when the page reloads with ?contact_posted=true, surface the ack.
  if (window.location.search.indexOf("contact_posted=true") !== -1) {
    const ack = document.querySelector("[data-form-ack]");
    if (ack) {
      ack.style.opacity = 1;
      setTimeout(() => { ack.style.opacity = 0; }, 6000);
    }
  }
})();
